import { gql } from "@apollo/client";


export const ADD_STANDARD_DECISION_TO_IDEA = gql`
    mutation AddStandardDecisionToIdea($ideaId: ID!, $standardsDecisionsToMakeId: ID!, $userId: ID!, $standardsDecisionsToMakeOptionsId: ID!) {

        addStandardDecisionToIdea(
          ideaId: $ideaId,
          standardsDecisionsToMakeId: $standardsDecisionsToMakeId,
          userId: $userId,
          standardsDecisionsToMakeOptionsId: $standardsDecisionsToMakeOptionsId) {
            id
        }
    }
`;

export const REMOVE_STANDARD_DECISION_FROM_IDEA = gql`
    mutation RemoveStandardDecisionFromIdea($ideaId: ID!, $standardsDecisionsToMakeId: ID!, $userId: ID!) {
        removeStandardDecisionFromIdea(ideaId: $ideaId, standardsDecisionsToMakeId: $standardsDecisionsToMakeId, userId: $userId) {
            id
        }
    }
`;